// import React from 'react'
// import { FaInstagram , FaLinkedinIn } from "react-icons/fa";
// import { IoMailOutline, } from "react-icons/io5";

// const Footer = () => {
//   return (
//     <section className="pt-10" >
//       <div className="container py-5 px-10 border-black border-t-2">
//         <div className="">
//             <div className="flex justify-end gap-3">
            
//               <a href="https://www.instagram.com/naina_joshi20/"><FaInstagram  className="text-2xl"/></a>
//               <a href="https://www.linkedin.com/in/naina-joshi-960863333/"><FaLinkedinIn className="text-2xl"/></a>
//               <a href="mailto:naman61265@gmail.com"><IoMailOutline className="text-2xl"/></a>
//             </div>
//         </div>
//       </div>

//       </section>
//   )
// }

// export default Footer
// import React from "react";
// import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
// import { IoMailOutline } from "react-icons/io5";

// const Footer = () => {
//   return (
//     <section className="pt-10">
//       <div className="container mx-auto py-5 px-5 sm:px-8 lg:px-10 border-black border-t-2">
//         <div className="flex flex-col sm:flex-row sm:justify-between items-center">
//           {/* Footer text (optional, e.g., brand or copyright) */}
//           <div className="mb-5 sm:mb-0">
//             <p className="text-sm sm:text-base lg:text-lg">
//               © 2024 Naina Joshi. All rights reserved.
//             </p>
//           </div>

//           {/* Social Media Icons */}
//           <div className="flex justify-center sm:justify-end gap-5">
//             <a
//               href="https://www.instagram.com/naina_joshi20/"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-2xl hover:text-pink-500 transition-colors duration-200"
//             >
//               <FaInstagram />
//             </a>
//             <a
//               href="https://www.linkedin.com/in/naina-joshi-960863333/"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-2xl hover:text-blue-700 transition-colors duration-200"
//             >
//               <FaLinkedinIn />
//             </a>
//             <a
//               href="mailto:naman61265@gmail.com"
//               className="text-2xl hover:text-red-500 transition-colors duration-200"
//             >
//               <IoMailOutline />
//             </a>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Footer;
import React from "react";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { IoMailOutline } from "react-icons/io5";

const Footer = () => {
  return (
    <footer className="pt-20">
      <div className="container mx-auto py-5 px-5 sm:px-8 lg:px-10 border-black border-t-2">
        <div className="flex flex-col sm:flex-row sm:justify-between items-center gap-4">
          {/* Footer text */}
          <div className="text-center sm:text-left">
            <p className="text-sm sm:text-base lg:text-lg text-gray-800">
              © 2024 Naina Joshi. All rights reserved.
            </p>
          </div>

          {/* Social Media Icons */}
          <div className="flex justify-center sm:justify-end gap-6">
            <a
              href="https://www.instagram.com/naina_joshi20/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl hover:text-pink-500 transition-colors duration-200"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/in/naina-joshi-960863333/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl hover:text-blue-700 transition-colors duration-200"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="mailto:nainajoshi6126@gmail.com"
              className="text-2xl hover:text-red-500 transition-colors duration-200"
              aria-label="Email"
            >
              <IoMailOutline />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
